// extracted by mini-css-extract-plugin
export default {"main":"main_main__BiDRY","left":"main_left__r+3pj","right":"main_right__iZ421"};